export const LOGIN_SERVICE_APP_NAME = "my vodacom: login (transaction)";
export const FORGOT_USERNAME_SERVICE_APP_NAME =
  "myvodacom: forgot username (transaction)";
export const FORGOT_PASSWORD_SERVICE_APP_NAME =
  "myvodacom: forgot password (transaction)";
export const REGISTRATION_SERVICE_APP_NAME =
  "myvodacom: registration (transaction)";
